import React from 'react'
import { Button, Card, Alert, Select } from '../../components'
import { useMemo } from 'react'
import FieldMask from '../../components/Field/FieldMask'

export default function LoginCpf({ service, history, filials }) {
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(null)
    const [code, setCode] = React.useState()
    const [cpf, setCpf] = React.useState('')
    const [birthdate, setBirthdate] = React.useState('')

    const canSubmit = useMemo(() => {
        if (
            cpf.trim().length !== 14 ||
            birthdate.trim().length !== 10 ||
            !code
        ) {
            return false
        }

        const [day, month, year] = birthdate.split('/')
        const birthdateFormatted = `${year}-${month}-${day}`
        const dateObj = new Date(birthdateFormatted)

        return !isNaN(dateObj.getTime())
    }, [cpf, birthdate, code])

    async function handleSubmit(evt) {
        evt.preventDefault()
        setError(null)
        setLoading(true)
        try {
            const [day, month, year] = birthdate.split('/')
            const birthdateFormatted = `${year}-${month}-${day}`
            const result = await service.prescriptionLogin({
                code,
                cpf,
                birthdate: birthdateFormatted,
            })
            localStorage.setItem('prescriptionUser', JSON.stringify(result))
            history.push('/prescricao')
        } catch (error) {
            setError(
                error.response?.data?.error || 'Erro ao efetuar login com CPF'
            )
            setLoading(false)
        }
    }

    React.useEffect(() => {
        const data = localStorage.getItem('prescriptionUser')
        if (data) {
            history.push('/prescricao')
        }
    }, [])

    const hasPosto = !!code

    return (
        <Card>
            <div className="ansTitle">Para obter suas prescrições</div>
            <form
                style={{ display: 'grid', gap: '10px', marginTop: '20px' }}
                onSubmit={handleSubmit}
            >
                <Select
                    placeholder="Escolha o posto"
                    value={code}
                    items={filials.map(e => ({ value: e.code, title: e.name }))}
                    style={{ color: hasPosto ? undefined : 'grey' }}
                    onChangeValue={setCode}
                />
                <FieldMask
                    type="cpf"
                    textFieldStyle={{ marginTop: 16 }}
                    label="CPF"
                    placeholder="Informe o CPF"
                    mask="cpf"
                    value={cpf}
                    onChange={e => setCpf(e.target.value)}
                />
                <FieldMask
                    textFieldStyle={{ marginTop: 16 }}
                    type="birthdate"
                    label="Data de nascimento"
                    placeholder="Informe a data de nascimento"
                    mask="birthdate"
                    value={birthdate}
                    onChange={e => setBirthdate(e.target.value)}
                />
                <div style={{ textAlign: 'right', marginTop: 16 }}>
                    <Button
                        isRequesting={loading}
                        type="submit"
                        disabled={!canSubmit || loading}
                        primary
                    >
                        {loading ? 'Acessando...' : 'Acessar prescrições'}
                    </Button>
                </div>

                {error && <Alert danger>{error}</Alert>}
            </form>
        </Card>
    )
}
